// Debug logging that cannot survive into a production bundle.
//
// Two independent conditions, deliberately. VITE_DEBUG is the developer's switch, but on
// its own it is only an environment variable: a `.env.production.local`, a CI variable,
// or a copied deploy config can set it, and then every call below runs in a real user's
// browser. That matters here more than in most apps because of what gets passed to these
// functions — apiClient logs raw error bodies from the billing proxy, which carry Stripe
// `client_secret` values, and SubmissionPage logs the user's own document text.
//
// import.meta.env.PROD is set by Vite from the BUILD MODE, not from any .env file, so it
// cannot be overridden by configuration. Requiring it makes a production build silent by
// construction. Both are inlined at build time, so the whole body is dead code the
// bundler drops — the arguments are never even evaluated.
const isDebug = import.meta.env.VITE_DEBUG === 'true' && !import.meta.env.PROD;

export const logger = {
  log: (...args: unknown[]) => {
    if (isDebug) {
      console.log('[DEBUG]', ...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isDebug) {
      console.error('[DEBUG ERROR]', ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDebug) {
      console.warn('[DEBUG WARN]', ...args);
    }
  },
};
